import { Modal } from './modal';

export class CookiePolicy {
    showModal() {
        if (typeof this.modal === "undefined") {
            this.modal = new Modal();
            this.modal.title = Unify.phrases.translations.internal.CookiePolicyLinkText;
            this.modal.message = Unify.phrases.translations.internal.CookiePolicy;
            this.modal.closeText = Unify.phrases.translations.common.Close;
        }
        this.modal.show();
    }
}
export var cookiePolicy = new CookiePolicy();
